import React, { ReactElement } from 'react';
import { Container } from 'react-bootstrap';
import { useBrand } from 'core/contexts/BrandContext';
import './HowItWorks.css';

interface HowItWorksProps {
  ctaUrl?: string;
}

export const HowItWorks = ({ ctaUrl }: HowItWorksProps): ReactElement => {
  const { contact, howItWorks } = useBrand();
  const cleanedNumber = contact.whatsappNumber.replace(/\D/g, '');
  const whatsappUrl = ctaUrl || `https://wa.me/${cleanedNumber}`;

  const stepIcons = [
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="6" y="2" width="12" height="20" rx="3" /><circle cx="12" cy="18" r="1" fill="currentColor" /></svg>,
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 11 2 2 4-4" /></svg>,
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>
  ];

  return (
    <section id="como-funciona" className="how-it-works-modern">
      <Container className="special-container py-4 py-md-5">
        <div className="title-decor-wrapper">
          <div className="title-decor-line"></div>
          <h2 className="section-title">{howItWorks.sectionTitle}</h2>
        </div>

        <div className="steps-horizontal">
          {howItWorks.steps.map((step, index) => (
            <div className="step-card" key={index}>
              <div className="step-icon-circle">
                <div className="step-icon-inner">
                  {stepIcons[index] || stepIcons[0]}
                </div>
                <span className="step-number-badge">{index + 1}</span>
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-text">{step.text}</p>
              <div className="step-connector"></div>
            </div>
          ))}

          <div className="cta-card-premium">
            <div className="cta-card-content">
              <h3 className="cta-title text-white">{howItWorks.cta.title}</h3>
              <p className="cta-text text-white">
                {howItWorks.cta.text}
              </p>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                {howItWorks.cta.buttonText}
              </a>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HowItWorks;
